module.exports = __webpack_public_path__ + "static/media/Credits-36.2ccce03e.pdf";